"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuppressionFilteringParameters = exports.SuppressionOrigin = exports.SuppressionReason = void 0;
var FilteringParameters_1 = require("../client/FilteringParameters");
var SuppressionReason;
(function (SuppressionReason) {
    SuppressionReason["HardBounce"] = "HardBounce";
    SuppressionReason["SpamComplaint"] = "SpamComplaint";
    SuppressionReason["ManualSuppression"] = "ManualSuppression";
})(SuppressionReason = exports.SuppressionReason || (exports.SuppressionReason = {}));
var SuppressionOrigin;
(function (SuppressionOrigin) {
    SuppressionOrigin["Recipient"] = "Recipient";
    SuppressionOrigin["Customer"] = "Customer";
    SuppressionOrigin["Admin"] = "Admin";
})(SuppressionOrigin = exports.SuppressionOrigin || (exports.SuppressionOrigin = {}));
/**
 * Describes filtering parameters that can be used when retrieving bounces.
 * When pagination parameters are not specified, default values are set.
 */
var SuppressionFilteringParameters = /** @class */ (function (_super) {
    __extends(SuppressionFilteringParameters, _super);
    function SuppressionFilteringParameters(count, offset, suppressionReason, origin, emailAddress, fromDate, toDate) {
        if (count === void 0) { count = 100; }
        if (offset === void 0) { offset = 0; }
        var _this = _super.call(this, count, offset) || this;
        _this.suppressionReason = suppressionReason;
        _this.origin = origin;
        _this.emailAddress = emailAddress;
        _this.fromDate = fromDate;
        _this.toDate = toDate;
        return _this;
    }
    return SuppressionFilteringParameters;
}(FilteringParameters_1.FilteringParameters));
exports.SuppressionFilteringParameters = SuppressionFilteringParameters;
//# sourceMappingURL=SuppressionFilteringParameters.js.map